<template>
  <div class="home">
    <NavbarItem />
    <div class="container">
      <HeroItem />
      <div class="row mt-4">
        <div class="col-12">
          <h2>Best <strong>Seller</strong></h2>
        </div>
        <!-- <div class="col">
          <router-link to="/foods" class="btn btn-success float-right">
            <b-icon-eye></b-icon-eye> Lihat semua
          </router-link>
        </div> -->
      </div>

      <div class="row mb-3 g-2">
        <div class="col-6 mt-2" v-for="product in products" :key="product.id">
          <CardProduct :product="product" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NavbarItem from "@/components/Navbar.vue";
import HeroItem from "@/components/Hero.vue";
import CardProduct from "@/components/CardProduct.vue";
import { api, apiRoutes } from "@/utils/api";

export default {
  name: "HomeView",
  components: {
    NavbarItem,
    HeroItem,
    CardProduct,
  },

  data() {
    return {
      products: [],
    };
  },
  methods: {
    setProducts(data) {
      this.products = data;
    },
  },
  async mounted() {
    try {
      const res = await api(apiRoutes.products, { method: "GET" });
      const list = Array.isArray(res.data) ? res.data : res.data?.data ?? [];
      this.setProducts(list);
    } catch (error) {
      console.log("Gagal", error);
    }
  },
};
</script>
